import IAppState from "./IAppState";
import IMainState from "./IMainState";
import ISummaryState from "./pages/SummaryPage/interfaces/ISummaryState";
import IJobState from "./pages/JobPage/interfaces/IJobState";
import IJobBtcResult from "./pages/JobPage/interfaces/IJobBtcResult";

export const mainInitialState: IMainState = {
    jobId: '',
    jobTitle: '',
    email: null,
    inputDataType: null,
    calculation: null,
    advancedOptions:{
    maxNumSeqField: 200,
    blastEvalField: 1e-10,
    minIdentityField: 30,
    maxIdentityField: 90,

    //advanced settings : identification of consensus residues
    majorityConsensusMinIdentity : 50,
    ratioConsensusMinFreq: 40,
    ratioConsensusMinRatio: 5,
    globalConsensusGapThreshold: 50,

    //advanced settings : threshold settings
    evolutionFoldXThreshold : 0.5,
    energyFoldXThreshold: -1,
    energyRosettaThreshold: -2,
    multipointRosettaThreshold: -2,
    limitForceFields: true,


    // advanced settings : analysis of correlated positions
    zScoreThreshold: 3.5,
    },
    pdbIdField: '',
    uniprotIdField: '',
    pdbChainField: '',
    processedStructure: {
        structures: [],
        nmr: false,
        },
    selectedStructureInfo: null,
    sitesAnotations: [],
    selectedSiteAnotations: null,
    userSiteAnnotations: [],
    //sequence: 'MVLSPADKTNVKAAWGKVGAHAGEYGAEALERMFLSFPTTKTYFPHFDLSHGSAQVKGHGKKVADALTNAVAHVDDMPNALSALSDLHAHKLRVDPVNFKLLSHCLLVTLAAHLPAEFTPAVHASLDKFLASVSTVLTSKYR',
    sequence: '',
    modelling: false,

    lowRiskDesign: false,
    highRiskDesign: true,
    ancestralDesign: false,

    sPMutations: [],
    userDefined: [],

    indexes: null,

    specifyChainsManually: false,
    chains: null,
    selectedChains: null,

    forceFieldMutations: true,
    bFactorAnalysis: true,
    consensusMutations: true,

    BTCmutations: [],
    LowRiskMutations: [],
    HighRiskMutations: [],
    CombinedLowRiskMutations: [],
    CombinedHighRiskMutations: [],
    ancestralDesigns: [],
    allResidues: [],

    showWaitingPDB: false,
    showWaitingCat: false,
    sequenceChecked: false,

    resultsLoaded: false,

    types: {
        noFF: true,
        btc: false,
        lowEnergy: false,
        highEnergy: false,
        lowCombined: false,
        highCombined: false,
        ancestrals: false
    },

    showChainsSelection: false,

    CustomMutantMutations: [],

    chainMapping: null,
}

export const summaryInitialState: ISummaryState = {
    jobId: '',
    jobTitle: '',
    email: '',
    exampleJobId: null,  // filled when the summary matches example job
    sequence:'',
}

export const jobInitialState: IJobState = {
    fetching: false,
    fetchFailed: false,
    fetchNotFound: false,
    jobInfo: null,

    inputFileFetching: false,
    inputFileFetchFailed: false,
    inputFileSucceed: false,

    rerunFetching: false,
    rerunFetchFailed: false,
    rerunSuccess: false,

}

export const jobResultsBtcInitialState: IJobBtcResult = {
    chain: '',
    residue: '',
    mutation: '',
    position: null,
    byMajority: false,
    byRatio: false,
    efoldx: null,
    erosetta: null,
}

export const initialState: IAppState = {

    mainState: mainInitialState,
    summaryState: summaryInitialState,
    jobState: jobInitialState,

};
